export default __webpack_public_path__ + "static/media/me2.2b865ca4.jpg";